/* Viva Bloom – effects and interactions for Viva Labrada */
(function () {
  'use strict';

  var T = window.VivaTheme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search/suggest' }, strings: {}, animations: true };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money format ---------- */
  function formatMoney(cents) {
    var format = T.moneyFormat || '${{amount}}';
    var value = Number(cents) / 100;
    function group(n, dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        default: return group(value, 0, '.', ',');
      }
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    var items = $$('[data-reveal]:not(.is-in)', scope);
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion || !T.animations) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // Make sure content shows even if the observer never fires (e.g. previews)
    setTimeout(function () { items.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1200);
  }

  /* ---------- Split hero heading into words ---------- */
  function splitWords() {
    if (reduceMotion) return;
    $$('[data-split]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      var i = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span');
              w.className = 'word';
              var inner = document.createElement('span');
              inner.style.setProperty('--w', i++);
              inner.textContent = part;
              w.appendChild(inner);
              frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            walk(child);
          }
        });
      };
      walk(el);
      el.classList.remove('hero-in');
      el.dataset.splitDone = '1';
    });
  }

  /* ---------- Falling petals ---------- */
  function Petals(canvas) {
    var ctx = canvas.getContext('2d');
    var colors = (canvas.dataset.colors || '#F2A7BB,#FFFFFF').split(',');
    var count = parseInt(canvas.dataset.density || '26', 10);
    var petals = [];
    var w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), running = true, rafId;

    function resize() {
      var r = canvas.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function make(initial) {
      return {
        x: Math.random() * w,
        y: initial ? Math.random() * h : -20,
        s: 6 + Math.random() * 10,
        vy: 0.35 + Math.random() * 0.8,
        vx: -0.3 + Math.random() * 0.6,
        rot: Math.random() * Math.PI * 2,
        vr: -0.02 + Math.random() * 0.04,
        sway: Math.random() * Math.PI * 2,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 0.55 + Math.random() * 0.4
      };
    }
    function drawPetal(p) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.scale(1, 0.6 + 0.4 * Math.abs(Math.sin(p.sway * 1.3)));
      ctx.globalAlpha = p.alpha;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.moveTo(0, -p.s);
      ctx.bezierCurveTo(p.s * 0.9, -p.s * 0.6, p.s * 0.7, p.s * 0.6, 0, p.s);
      ctx.bezierCurveTo(-p.s * 0.7, p.s * 0.6, -p.s * 0.9, -p.s * 0.6, 0, -p.s);
      ctx.fill();
      ctx.globalAlpha = p.alpha * 0.35;
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.moveTo(0, -p.s * 0.7); ctx.lineTo(0, p.s * 0.7); ctx.stroke();
      ctx.restore();
    }
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      petals.forEach(function (p, i) {
        p.sway += 0.015;
        p.x += p.vx + Math.sin(p.sway) * 0.6;
        p.y += p.vy;
        p.rot += p.vr;
        if (p.y > h + 20 || p.x < -30 || p.x > w + 30) petals[i] = make(false);
        drawPetal(p);
      });
      rafId = requestAnimationFrame(tick);
    }
    resize();
    for (var i = 0; i < count; i++) petals.push(make(true));
    window.addEventListener('resize', resize);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        running = entries[0].isIntersecting;
        cancelAnimationFrame(rafId);
        if (running) tick();
      }).observe(canvas);
    } else { tick(); }
  }

  function petalTrail(canvas) {
    if (window.matchMedia('(hover: none)').matches) { canvas.remove(); return; }
    var ctx = canvas.getContext('2d'), parts = [], last = 0;
    function resize() { canvas.width = innerWidth; canvas.height = innerHeight; }
    resize(); window.addEventListener('resize', resize);
    window.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - last < 45) return;
      last = now;
      parts.push({ x: e.clientX, y: e.clientY, s: 4 + Math.random() * 4, life: 1, r: Math.random() * 6, vx: -0.5 + Math.random(), vy: 0.6 + Math.random() });
    });
    (function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      parts = parts.filter(function (p) { return p.life > 0; });
      parts.forEach(function (p) {
        p.life -= 0.018; p.x += p.vx; p.y += p.vy; p.r += 0.05;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.globalAlpha = Math.max(p.life, 0) * 0.8;
        ctx.fillStyle = '#F2A7BB';
        ctx.beginPath(); ctx.ellipse(0, 0, p.s, p.s * 0.55, 0, 0, Math.PI * 2); ctx.fill(); ctx.restore();
      });
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Announcement bar ---------- */
  function initAnnouncement() {
    $$('[data-announce]').forEach(function (bar) {
      var slides = $$('.announce__slide', bar);
      if (slides.length < 2 || reduceMotion) return;
      var i = 0, interval = parseInt(bar.dataset.interval || '4000', 10);
      setInterval(function () {
        var cur = slides[i];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 520);
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------- Countdowns ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var set = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = pad(v); };
      (function update() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) { el.hidden = true; return; }
        set('[data-cd-d]', Math.floor(diff / 864e5));
        set('[data-cd-h]', Math.floor(diff / 36e5) % 24);
        set('[data-cd-m]', Math.floor(diff / 6e4) % 60);
        set('[data-cd-s]', Math.floor(diff / 1e3) % 60);
        setTimeout(update, 1000);
      })();
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastY = window.scrollY;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      if (header.hasAttribute('data-sticky')) {
        header.classList.toggle('is-hidden', y > lastY && y > 300 && !header.querySelector('[data-search-panel]:not([hidden])'));
      }
      lastY = y;
      var top = $('[data-back-to-top]');
      if (top) top.classList.toggle('is-visible', y > 800);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var panel = $('[data-search-panel]', header);
    $$('[data-search-toggle]', header).forEach(function (btn) {
      btn.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var input = $('input[type="search"]', panel); input && input.focus(); }
      });
    });

    var input = $('[data-predictive-input]', header);
    var results = $('[data-predictive-results]', header);
    var timer;
    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          fetch(T.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var items = (data.resources && data.resources.results && data.resources.results.products) || [];
              results.innerHTML = items.length
                ? '<div class="predictive">' + items.map(function (p) {
                    var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
                    return '<a href="' + p.url + '">' + img + '<span><strong>' + p.title + '</strong><br><small>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
                  }).join('') + '</div>'
                : '';
            }).catch(function () {});
        }, 250);
      });
    }

    var btt = $('[data-back-to-top]');
    if (btt) btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- Drawers ---------- */
  var lastFocus;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    focusable && setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-drawer].is-open').forEach(closeDrawer);
  });

  /* ---------- AJAX cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
    var current = $('[data-cart-drawer] .drawer__panel');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function refreshCart() {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { renderDrawer(s['cart-drawer']); return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 500); }, 2600);
  }
  function flyToCart(fromEl) {
    var target = $('.header__cart');
    if (!fromEl || !target || reduceMotion) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'fly-dot';
    dot.style.left = a.left + a.width / 2 + 'px';
    dot.style.top = a.top + a.height / 2 + 'px';
    document.body.appendChild(dot);
    dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.4)', opacity: .6 }
    ], { duration: 700, easing: 'cubic-bezier(.5,-0.3,.6,1)' }).onfinish = function () { dot.remove(); };
  }
  function addToCart(formData, button) {
    var drawer = $('[data-cart-drawer]');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    button && button.setAttribute('aria-busy', 'true');
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || 'Something went wrong'); return; }
        flyToCart(button);
        if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']);
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
        if (drawer) setTimeout(function () { openDrawer('CartDrawer'); }, reduceMotion ? 0 : 450);
        else toast(T.strings.added || 'Added to cart');
      })
      .catch(function () { if (button && button.form) button.form.submit(); })
      .finally(function () { button && button.removeAttribute('aria-busy'); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]')) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      var fd = new FormData(); fd.append('id', quick.getAttribute('data-quick-add')); fd.append('quantity', '1');
      addToCart(fd, quick);
      return;
    }
    var remove = e.target.closest('[data-cart-drawer] [data-remove-line]');
    if (remove) { changeLine(remove.getAttribute('data-remove-line'), 0); }
  });
  function changeLine(line, qty) {
    var drawer = $('[data-cart-drawer]');
    drawer && drawer.classList.add('is-loading');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
      updateCount(cart.item_count || 0);
    }).finally(function () { drawer && drawer.classList.remove('is-loading'); });
  }

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches('[data-cart-drawer] .qty__input[data-line]')) changeLine(input.dataset.line, input.value);
  });

  /* ---------- Collection tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (wrap) {
      var tabs = $$('[data-tab]', wrap), ink = $('.ctabs__ink', wrap);
      var moveInk = function (tab) {
        if (!ink || !tab) return;
        ink.style.width = tab.offsetWidth + 'px';
        ink.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      };
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
          $$('[data-panel]', wrap).forEach(function (p) {
            var on = p.dataset.panel === tab.dataset.tab;
            p.hidden = !on; p.classList.toggle('is-active', on);
            if (on) initReveal(p);
          });
          moveInk(tab);
        });
      });
      moveInk($('.ctabs__tab.is-active', wrap));
      window.addEventListener('resize', function () { moveInk($('.ctabs__tab.is-active', wrap)); });
    });
  }

  /* ---------- Testimonial slider ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (s) {
      var track = $('[data-slider-track]', s);
      if (!track) return;
      var step = function (dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 24 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      var prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Journey, counters, parallax ---------- */
  function initScrollEffects() {
    var journeys = $$('[data-journey]');
    var parallax = $$('[data-parallax] img');
    var counters = $$('[data-count-to]');

    if (counters.length && 'IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var el = e.target, to = parseFloat(el.dataset.countTo) || 0, start = performance.now(), dur = 1600;
          (function frame(now) {
            var t = Math.min(1, (now - start) / dur), eased = 1 - Math.pow(1 - t, 3);
            el.textContent = Math.round(to * eased).toLocaleString('en-US');
            if (t < 1) requestAnimationFrame(frame);
          })(start);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { c.textContent = '0'; io.observe(c); });
    } else {
      counters.forEach(function (c) { c.textContent = Number(c.dataset.countTo).toLocaleString('en-US'); });
    }

    if (reduceMotion) { journeys.forEach(function (j) { $$('.journey__step', j).forEach(function (s) { s.classList.add('is-lit'); }); }); return; }
    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight;
      journeys.forEach(function (j) {
        var r = j.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh * 0.75 - r.top) / (r.height * 0.7)));
        var bar = $('[data-journey-progress]', j);
        bar && bar.style.setProperty('--progress', p.toFixed(3));
        var steps = $$('.journey__step', j);
        steps.forEach(function (s, i) { s.classList.toggle('is-lit', p >= (i + 0.5) / steps.length); });
      });
      parallax.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var off = ((r.top + r.height / 2) - vh / 2) / vh;
        img.style.setProperty('--parallax', (off * -40).toFixed(1) + 'px');
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('form[data-ajax-cart]', section);
    var idInput = $('[data-variant-id]', section);
    var atc = $('[data-add-to-cart]', section);
    var atcText = $('[data-atc-text]', section);
    var stickyBar = $('[data-sticky-atc]', section);
    var currentVariant = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    // Gallery
    var slides = $$('.pdp__slide', section), thumbs = $$('[data-thumb]', section);
    var show = function (mediaId) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === String(mediaId)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(mediaId)); });
    };
    var step = function (dir) {
      var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var next = slides[(idx + dir + slides.length) % slides.length];
      next && show(next.dataset.mediaId);
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.thumb); }); });
    var prev = $('[data-gallery-prev]', section), nxt = $('[data-gallery-next]', section);
    prev && prev.addEventListener('click', function () { step(-1); });
    nxt && nxt.addEventListener('click', function () { step(1); });
    var stage = $('[data-gallery-stage]', section), sx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        sx = null;
      });
    }
    $$('[data-zoom]', section).forEach(function (z) {
      if (window.matchMedia('(hover: none)').matches) return;
      z.addEventListener('mousemove', function (e) {
        var r = z.getBoundingClientRect();
        z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      z.addEventListener('click', function () { z.classList.toggle('is-zoomed'); });
      z.addEventListener('mouseleave', function () { z.classList.remove('is-zoomed'); });
    });

    // Quantity breaks
    var bundleWrap = $('[data-bundles]', section);
    var qtyHidden = $('[data-quantity-hidden]', section);
    var updateBundles = function () {
      if (!bundleWrap) return;
      $$('.bundle', bundleWrap).forEach(function (label) {
        var input = $('input', label);
        var qty = Number(input.dataset.bundleQty), off = Number(input.dataset.bundleOff);
        var full = currentVariant.price * qty, pay = Math.round(full * (100 - off) / 100);
        var payEl = $('[data-bundle-pay]', label), fullEl = $('[data-bundle-full]', label);
        payEl && (payEl.textContent = formatMoney(pay));
        fullEl && (fullEl.textContent = formatMoney(full));
        label.classList.toggle('is-active', input.checked);
        if (input.checked && qtyHidden) qtyHidden.value = qty;
      });
    };
    if (bundleWrap) bundleWrap.addEventListener('change', updateBundles);
    updateBundles();

    // Variant picker
    var picker = $('[data-variant-picker]', section);
    var updateVariant = function () {
      if (!picker) return;
      var selected = $$('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      $$('fieldset', picker).forEach(function (fs, i) {
        var lbl = $('[data-option-label="' + i + '"]', picker);
        if (lbl) lbl.textContent = selected[i];
      });
      var v = product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === selected[i]; });
      });
      // Mark unavailable options
      $$('input[type="radio"]', picker).forEach(function (input) {
        var idx = Number(input.dataset.optionIndex);
        var test = selected.slice(); test[idx] = input.value;
        var match = product.variants.find(function (variant) { return variant.options.every(function (o, i) { return o === test[i]; }); });
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
      if (!v) {
        atc.disabled = true; atcText.textContent = T.strings.unavailable || 'Unavailable';
        return;
      }
      currentVariant = v;
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcText.textContent = v.available ? (T.strings.addToCart || 'Add to cart') : (T.strings.soldOut || 'Sold out');
      var priceWrap = $('.pdp__price [data-price-wrapper]', section);
      if (priceWrap) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        var p = $('[data-price]', priceWrap), c = $('[data-compare-price]', priceWrap), b = $('[data-saving-badge]', priceWrap);
        p && (p.textContent = formatMoney(v.price));
        if (c) { c.hidden = !onSale; if (onSale) c.textContent = formatMoney(v.compare_at_price); }
        if (b) {
          b.hidden = !onSale;
          if (onSale) b.textContent = b.textContent.replace(/\d+%/, Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
        }
      }
      var sp = $('[data-sticky-price]', section);
      sp && (sp.textContent = formatMoney(v.price));
      var sb = $('[data-sticky-submit]', section);
      sb && (sb.disabled = !v.available);
      if (v.featured_media) show(v.featured_media.id);
      updateBundles();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    if (picker) picker.addEventListener('change', updateVariant);

    // Sticky add-to-cart
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', past);
        stickyBar.setAttribute('aria-hidden', String(!past));
      }).observe(atc);
      var sb = $('[data-sticky-submit]', stickyBar);
      sb && sb.addEventListener('click', function () {
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initReveal(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Filters & sorting ---------- */
  function initCollection() {
    $$('[data-dropdown]').forEach(function (dd) {
      var items = $$('.dropdown__item', dd);
      var focusSelected = function () { var cur = $('.dropdown__item.is-selected', dd) || items[0]; cur && cur.focus(); };
      dd.addEventListener('toggle', function () { if (dd.open) setTimeout(focusSelected, 30); });
      dd.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dd.open) { dd.open = false; $('summary', dd).focus(); return; }
        if (!dd.open || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
        e.preventDefault();
        var i = items.indexOf(document.activeElement);
        var next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        next && next.focus();
      });
      items.forEach(function (item) {
        item.addEventListener('click', function (e) {
          if (!item.dataset.sortValue) return;
          e.preventDefault();
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', item.dataset.sortValue);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    });
    document.addEventListener('click', function (e) {
      $$('[data-dropdown][open]').forEach(function (dd) { if (!dd.contains(e.target)) dd.open = false; });
    });
    var form = $('[data-filter-form]');
    if (form) {
      var t;
      form.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var params = new URLSearchParams(new FormData(form));
          Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
          window.location.search = params.toString();
        }, 400);
      });
    }
  }

  /* ---------- Benefits catalog filter ---------- */
  function initBenefits(scope) {
    $$('[data-bcat]', scope).forEach(function (wrap) {
      var chips = $$('[data-need]', wrap), cards = $$('[data-needs]', wrap);
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var need = chip.dataset.need;
          chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', String(on)); });
          cards.forEach(function (card) {
            var show = need === 'all' || (' ' + card.dataset.needs + ' ').indexOf(' ' + need + ' ') > -1;
            card.classList.toggle('is-hidden', !show);
            if (show) { card.classList.remove('is-in'); void card.offsetWidth; card.classList.add('is-in'); }
          });
        });
      });
    });
  }

  /* ---------- Recent order pop-up ---------- */
  function initSalesPopup() {
    var el = $('[data-sales-popup]');
    if (!el) return;
    var data;
    try { data = JSON.parse($('[data-sales-popup-data]', el).textContent); } catch (e) { return; }
    var people = (data.people || []).map(function (p) { return p.trim(); }).filter(Boolean);
    if (!people.length || !data.products || !data.products.length) return;
    var closed = false;
    try { closed = sessionStorage.getItem('viva-popup-closed') === '1'; } catch (e) {}
    if (closed) return;
    el.hidden = false;
    var showOne = function () {
      var who = people[Math.floor(Math.random() * people.length)].split('|');
      var prod = data.products[Math.floor(Math.random() * data.products.length)];
      $('[data-sales-popup-who]', el).textContent = (who[0] || '').trim() + (who[1] ? ' (' + who[1].trim() + ')' : '') + ' ' + data.bought;
      var link = $('[data-sales-popup-link]', el); link.textContent = prod.title; link.href = prod.url;
      $('[data-sales-popup-media]', el).innerHTML = prod.image ? '<img src="' + prod.image + '" alt="">' : '';
      el.classList.add('is-visible');
      setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
    };
    var timer = setInterval(showOne, 18000);
    setTimeout(showOne, 8000);
    $('[data-sales-popup-close]', el).addEventListener('click', function () {
      el.classList.remove('is-visible'); clearInterval(timer);
      try { sessionStorage.setItem('viva-popup-closed', '1'); } catch (e) {}
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    splitWords();
    initReveal(document);
    if (!reduceMotion) {
      $$('[data-petals]').forEach(function (c) { new Petals(c); });
      var trail = $('.petal-trail');
      trail && petalTrail(trail);
    }
    initAnnouncement();
    initCountdowns();
    initHeader();
    initTabs();
    initSliders();
    initScrollEffects();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    initCollection();
    initBenefits(document);
    initSalesPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run effects when a section is added or edited
  document.addEventListener('shopify:section:load', function (e) {
    splitWords();
    initReveal(e.target);
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
    if (!reduceMotion) $$('[data-petals]', e.target).forEach(function (c) { new Petals(c); });
    initTabs(); initSliders(); initCountdowns(); initBenefits(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
  });
})();
